export default __webpack_public_path__ + "static/media/epl-banner-indo.9df0d786.webp";